export enum RebalancingMonthlyMonthlyReturnInterval {
  LAST_DAY = 'Last Day',
}
